import { render, staticRenderFns } from "./Jtron.vue?vue&type=template&id=5e515ebf&scoped=true&"
import script from "./Jtron.vue?vue&type=script&lang=js&"
export * from "./Jtron.vue?vue&type=script&lang=js&"
import style0 from "./Jtron.vue?vue&type=style&index=0&id=5e515ebf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e515ebf",
  null
  
)

export default component.exports